import { gameKindRegistry } from "./kinds/registry";
import { GameSpecValidationError, record } from "./kinds/shared/validators";
import type { CarcadeGameSpec, GameKind } from "./kinds/spec-types";

export type { CarcadeGameSpec, GameKind } from "./kinds/spec-types";
export { GameSpecValidationError } from "./kinds/shared/validators";

function isKnownKind(kind: unknown): kind is GameKind {
  return typeof kind === "string" && Object.prototype.hasOwnProperty.call(gameKindRegistry, kind);
}

/**
 * Parses model/browser JSON into a validated, versioned `CarcadeGameSpec`.
 * Dispatches to the named kind's own closed-world parser -- unknown or
 * missing keys, wrong types, and out-of-range values are all rejected there,
 * exactly as the single-kind parser rejected them before the kind registry
 * existed. Only the kind names accepted here changes as kinds are added.
 */
export function parseCarcadeGameSpec(value: unknown): CarcadeGameSpec {
  const root = record(value, "game spec");
  if (root.version !== 1) throw new GameSpecValidationError("game spec.version must be 1");
  if (!isKnownKind(root.kind)) throw new GameSpecValidationError("unsupported game kind");
  return gameKindRegistry[root.kind].parseSpec(root) as CarcadeGameSpec;
}
